<script lang="ts">
	import Fa from 'svelte-fa';
	import type { IconDefinition } from '@fortawesome/free-solid-svg-icons';

	interface Props {
		icon?: IconDefinition | undefined;
		title: string;
		iconClass?: string;
		titleClass?: string;
		containerClass?: string;
	}

	let {
		icon = undefined,
		title,
		iconClass = 'text-primary-500',
		titleClass = 'text-lg font-medium',
		containerClass = 'mb-6 flex items-center gap-3'
	}: Props = $props();
</script>

<h3 class={containerClass}>
	{#if icon}
		<Fa {icon} class={iconClass} />
	{/if}
	<span class={titleClass}>{title}</span>
</h3>
